/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_GenresInputs */

const id_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ms_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const da_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const de_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const en_us2_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const es_es2_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const es_mx2_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const fil_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Genre`)
};

const fr_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const it_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generi`)
};

const hu_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfajok`)
};

const nl_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const no_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjangre`)
};

const pl_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunki`)
};

const pt_br2_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const pt_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Géneros`)
};

const ro_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genuri`)
};

const fi_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityypit`)
};

const sv_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genrer`)
};

const vi_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại`)
};

const tr_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Türler`)
};

const cs_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánry`)
};

const bg_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанрове`)
};

const ru_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанры`)
};

const uk_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанри`)
};

const ar_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأنواع`)
};

const hi_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैलियाँ`)
};

const th_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนวเกม`)
};

const ja_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_cn2_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const zh_hant1_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

const ko_components_comparison_genres = /** @type {(inputs: Components_Comparison_GenresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genres`)
};

/**
* | output |
* | --- |
* | "Genres" |
*
* @param {Components_Comparison_GenresInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_genres = /** @type {((inputs?: Components_Comparison_GenresInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_GenresInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_genres(inputs)
	if (locale === "ms") return ms_components_comparison_genres(inputs)
	if (locale === "da") return da_components_comparison_genres(inputs)
	if (locale === "de") return de_components_comparison_genres(inputs)
	if (locale === "en-US") return en_us2_components_comparison_genres(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_genres(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_genres(inputs)
	if (locale === "fil") return fil_components_comparison_genres(inputs)
	if (locale === "fr") return fr_components_comparison_genres(inputs)
	if (locale === "it") return it_components_comparison_genres(inputs)
	if (locale === "hu") return hu_components_comparison_genres(inputs)
	if (locale === "nl") return nl_components_comparison_genres(inputs)
	if (locale === "no") return no_components_comparison_genres(inputs)
	if (locale === "pl") return pl_components_comparison_genres(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_genres(inputs)
	if (locale === "pt") return pt_components_comparison_genres(inputs)
	if (locale === "ro") return ro_components_comparison_genres(inputs)
	if (locale === "fi") return fi_components_comparison_genres(inputs)
	if (locale === "sv") return sv_components_comparison_genres(inputs)
	if (locale === "vi") return vi_components_comparison_genres(inputs)
	if (locale === "tr") return tr_components_comparison_genres(inputs)
	if (locale === "cs") return cs_components_comparison_genres(inputs)
	if (locale === "bg") return bg_components_comparison_genres(inputs)
	if (locale === "ru") return ru_components_comparison_genres(inputs)
	if (locale === "uk") return uk_components_comparison_genres(inputs)
	if (locale === "ar") return ar_components_comparison_genres(inputs)
	if (locale === "hi") return hi_components_comparison_genres(inputs)
	if (locale === "th") return th_components_comparison_genres(inputs)
	if (locale === "ja") return ja_components_comparison_genres(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_genres(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_genres(inputs)
	return ko_components_comparison_genres(inputs)
});
export { components_comparison_genres as "components.comparison.genres" }